import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { LoggerService } from './logger.service';
import {UrlConstants} from './url.constant';

@Injectable()
export class HTTPHelperService {

  public token: string;

  constructor(private logger: LoggerService, private http: HttpClient) {
  }

  public headers = new HttpHeaders();

  // url    : The api url which used to call the function
  // params : The variable which is used to pass the query string or the params

  // Function for GET operations
  public getFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::getFunction::Exception:: ' + err);
    }
    return this.http.get(url + params, { headers: this.headers }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }

  // Function for GET file Operations
  public getFileFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::getFunction::Exception:: ' + err);
    }
    return this.http.get(url + params, { headers: this.headers, responseType: 'blob' }).toPromise()
      .then().catch(this.handleError);
  }

  // Function for POST operations
  public postFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
      this.setHeaders();
    } catch (err) {
      this.logger.error('webapi.services::postFunction::Exception:: ' + err);
    }
    return this.http.post(url, params, { headers: this.headers }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }

  // Function for POST operations
  public postWitoutHeaderFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
    } catch (err) {
      this.logger.error('webapi.services::postFunction::Exception:: ' + err);
    }
    return this.http.post(url, params, { headers: this.headers }).toPromise()
      .then().catch(this.handleError);
  }

  // Function for POST operations
  public postImageUpload(url, formData): Promise<any> {
    try {
      formData = (formData != null) ? formData : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postImageUpload::Exception:: ' + err);
    }
    const fileHeader = new HttpHeaders();
    /** In Angular 5, including the header Content-Type can invalidate your request */
    fileHeader.append('Content-Type', 'multipart/form-data');
    fileHeader.append('Accept', 'application/json');
    return this.http.post(url, formData, { headers: fileHeader }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }

  // Function for POST operations
  public postPdfDownload({url, params}) {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postPdfDownload::Exception:: ' + err);
    }
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
        'Authorization': 'Bearer ' + this.token,
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.post(url, params, httpOptions);
  }

  // Function for POST operations
  public postTcPdfDownload({url, params}) {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postTcPdfDownload::Exception:: ' + err);
    }
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
        'Authorization': 'Bearer ' + this.token,
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.post(url, params, httpOptions);
  }

    // Function for POST operations
  public downloadReport({url, params}) {
    try {
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postPdfDownload::Exception:: ' + err);
    }
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.token
      })
    };
    return this.http.get(url, httpOptions);
  }

  public postPdfMerge({url, params}) {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postPdfDownload::Exception:: ' + err);
    }
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
        'Authorization': 'Bearer ' + this.token,
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.post(url, params, httpOptions);
  }

  // Function for PUT operations
  public putFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
      this.setHeaders();
    } catch (err) {
      this.logger.error('webapi.services::putFunction::Exception:: ' + err);
    }
    return this.http.put(url, params, { headers: this.headers }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }

  // Function for DELETE operations
  public deleteFunction({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::deleteFunction::Exception:: ' + err);
    }
    return this.http.delete(url + params, { headers: this.headers }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }

  // Function for set the headers
  // Here the header object appends with Authorization(Bearer token),cityId and Content-Type parameters
  private setHeaders(isGet: boolean = false) {
    try {
      if (localStorage.getItem('userToken') != null && localStorage.getItem('userToken').length > 0) {
        this.token = localStorage.getItem('userToken');
      }
      this.headers = new HttpHeaders();
      this.headers = this.headers.set('Authorization', 'Bearer ' + this.token);
      if (isGet) {
        this.headers = this.headers.set('Content-Type', 'application/json');
      }
    } catch (err) {
      this.logger.error('webapi.services::setHeaders::Exception:: ' + err);
    }
  }

   // Function for set the headers
  // Here the header object appends with Authorization(Bearer token),cityId and Content-Type parameters
  private setImageHeaders() {
    try {

      this.headers = new HttpHeaders();
      this.headers = this.headers.set('Access-Control-Request-Header', 'Content-Type,Access-Control-Allow-Origin,x-goog-resumable');
      this.headers = this.headers.set('Authorization', 'Bearer ' + this.token);
      this.headers = this.headers.set('Content-Type', 'image/jpeg');
    } catch (err) {
      this.logger.error('webapi.services::setHeaders::Exception:: ' + err);
    }
  }


  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  private handleError(err: any): Promise<any> {
    console.log(err);
    console.error('An error occurred', err);
    return Promise.reject(err.error || err);
  }

  // Function for POST operations
  public postFileUpload(req) {
    return this.http.request(req);
  }

  // Function for PUT operations
  public putFunctionForImage({ url, params }): Promise<any> {
    try {
      params = (params != null) ? params : '';
    //  this.setImageHeaders()
      this.setHeaders();
     // this.headers.set('Content-Type', 'image/jpeg')
    // this.setHeaders()
    } catch (err) {
      this.logger.error('webapi.services::putFunction::Exception:: ' + err);
    }
    return this.http.put(url, params, { headers: this.headers }).toPromise()
      .then(this.extractData).catch(this.handleError);
  }
  public downloadReport1({url, params}) {
    try {
      params = (params != null) ? params : '';
      this.setHeaders(true);
    } catch (err) {
      this.logger.error('webapi.services::postPdfDownload::Exception:: ' + err);
    }
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
        'Authorization': 'Bearer ' + this.token,
        'Access-Control-Allow-Origin': '*'
      })
    };
    return this.http.post(url, params, httpOptions);
  }
}
